import moment from "moment";
import notification from "antd/lib/notification";
import { WDQMS_API, fetchData } from "../../utils/api";
import { isEmpty, setError404 } from "./actions";
import {
  setProperty,
  setPeriodDataKey,
  updatePeriodTypes
} from "./actions";

// Global variables for tracking fetch status
let sixHourFetched = false;
let dailyFetched = false;

// Load the initial periods of six-hour and daily periods
export function loadInitialPeriods(page_size, pageType, payload, baseline, dispatch) {
  let date_param = "";
  if (payload.params["date"]) {
    date_param = `&date=${payload.params["date"]}`;
    if (payload.params.periodType === "monthly") {
      // convert date param from YYYY-MM to YYYY-MM-01
      date_param = ``;
    }
  }
  let url = "";
  if (
    payload.fileType === "synop" ||
    payload.fileType === "temp" ||
    payload.fileType === "buoy" ||
    payload.fileType === "ship" ||
    payload.fileType === "marine_surface" ||
    payload.fileType === "gbon_synop" ||
    payload.fileType === "gbon_temp"
  ) {
    let file_type = payload.fileType;
    let baselineParam = "";
    if (baseline === "GBON") {
      file_type = payload.parentFileType;
      baselineParam = `&baseline=${baseline}`;
    }
    url = `${WDQMS_API}/sixhour-periods/?file_type=${file_type}&limit=${page_size}${date_param}${baselineParam}${pageType}`;
  } else {
    url = `${WDQMS_API}/periods/?file_type=${payload.fileType}&limit=${page_size}${date_param}${pageType}`;
  }
  return fetchData(url)
    .then(response => {
      if (response.data.length === 0) {
        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "six_hour",
            key: "noData",
            value: true
          })
        );
        // set the data (for a particular fileType) as fetched
        // so that won't be fetched a second time
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "dataFetched",
            value: true
          })
        );
        return false;
      } else {
        sixHourFetched = true;
        if (isEmpty(payload.params)) {
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedPeriodType",
              value: "six_hour"
            })
          );
        }

        dispatch(
          updatePeriodTypes({
            type: payload.fileType,
            value: "six_hour"
          })
        );
        let tempObj = {};
        for (let p of response.data.results) {
          if (!tempObj[p.center]) {
            tempObj[p.center] = {};
          }
          if (!tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")]) {
            tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")] = {
              "00": { available: false, id: null },
              "06": { available: false, id: null },
              "12": { available: false, id: null },
              "18": { available: false, id: null }
            };
          }
          tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
            moment.utc(p.date).format("HH")
          ].available = true;
          tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
            moment.utc(p.date).format("HH")
          ].id = p.id;
        }
        // The object that contains the dates for the 'combined' version (all centers)
        let objectAll = {};
        // loop through all centers
        for (let ct of Object.keys(tempObj)) {
          // loop through all dates
          for (let d of Object.keys(tempObj[ct])) {
            // if objectAll doesn't have the key 'd'
            if (!Object.keys(objectAll).includes(d)) {
              objectAll[d] = {};
              // loop through the 4 six-hour periods
              for (let p of Object.keys(tempObj[ct][d])) {
                if (tempObj[ct][d][p].available) {
                  objectAll[d][p] = {};
                  objectAll[d][p].available = true;
                  objectAll[d][p].id = {};
                  objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
                } else {
                  objectAll[d][p] = {
                    available: false,
                    id: {}
                  };
                }
              }
            } else {
              for (let p of Object.keys(tempObj[ct][d])) {
                if (tempObj[ct][d][p].available) {
                  objectAll[d][p].available = true;
                  objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
                }
              }
            }
          }
        }
        tempObj.all = objectAll;

        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "six_hour",
            key: "dates",
            value: tempObj
          })
        );
        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "six_hour",
            key: "centers",
            // case insensitive sort so that "all" is first element
            value: Object.keys(tempObj).sort(function(a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            })
          })
        );

        let latestDate;
        let availablePeriods;
        if (isEmpty(payload.params)) {
          const firstCenter = Object.keys(tempObj).sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          })[0];
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedCenter",
              value: firstCenter
            })
          );

          latestDate = Object.keys(tempObj[firstCenter]).sort()[
            Object.keys(tempObj[firstCenter]).length - 1
          ];
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedDate",
              value: latestDate
            })
          );

          availablePeriods = tempObj[firstCenter][latestDate];

          const arrAvailablePeriods = Object.keys(availablePeriods)
            .sort()
            .filter(p => availablePeriods[p].available);

          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedSixHPeriod",
              value: arrAvailablePeriods[arrAvailablePeriods.length - 1]
            })
          );
        } else if (payload.params.periodType === "six_hour") {
          latestDate = payload.params.date;
          // check if the date exist
          if (tempObj[payload.params.center][latestDate]) {
            availablePeriods = tempObj[payload.params.center][latestDate];

            dispatch(
              setProperty({
                type: payload.fileType,
                key: "selectedSixHPeriod",
                value: payload.params.period
              })
            );

            // if the date doesn't exist, trigger an error
          } else {
            dispatch(setError404());
          }

          // if the six-hour period is not available for this date,
          // also trigger an error
          if (
            tempObj[payload.params.center][latestDate] &&
            typeof payload.params.period !== "undefined"
          ) {
            if (!availablePeriods[payload.params.period].available) {
              dispatch(setError404());
            }
          }
        }

        dispatch(
          setProperty({
            type: payload.fileType,
            key: "currentSixHPeriods",
            value: availablePeriods
          })
        );

        if (
          isEmpty(payload.params) ||
          payload.params.periodType === "six_hour"
        ) {
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "readyToFillMenu",
              value: true
            })
          );
        }

        // set the data (for a particular fileType) as fetched
        // so that won't be fetched a second time
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "dataFetched",
            value: true
          })
        );
        return true;
      }
    })
    .catch(error => {
      // If there are URL params requesting the six-hour data
      // and an error while fetching the six-hour data, trigger an error
      if (
        !isEmpty(payload.params) &&
        payload.params.periodType === "six_hour"
      ) {
        dispatch(setError404());
      }

      sixHourFetched = false;

      notification.error({
        message: "Error fetching API",
        description: "There was an error while fetching the six-hour data",
        top: 100,
        duration: 0
      });
      dispatch(
        setPeriodDataKey({
          subObj: "periodData",
          type: payload.fileType,
          period: "six_hour",
          key: "errorFetchingApi",
          value: true
        })
      );
      return false;
    });
}

// Load all six-hour periods asynchronously and return the data
export async function loadAllPeriods(payload, pageType, baseline = "Oscar") {
  let data = [];
  let file_type = payload.fileType;
  let baselineParam = "";
  if (baseline === "GBON") {
    file_type = payload.parentFileType;
    baselineParam = `&baseline=${baseline}`;
  }
  let url = `${WDQMS_API}/sixhour-periods/?file_type=${file_type}${baselineParam}${pageType}`;
  let response = await fetchData(url);
  let tempObj = {};
  for (let p of response.data.results) {
    if (!tempObj[p.center]) {
      tempObj[p.center] = {};
    }
    if (!tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")]) {
      tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")] = {
        "00": { available: false, id: null },
        "06": { available: false, id: null },
        "12": { available: false, id: null },
        "18": { available: false, id: null }
      };
    }
    tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
      moment.utc(p.date).format("HH")
    ].available = true;
    tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
      moment.utc(p.date).format("HH")
    ].id = p.id;
  }
  // The object that contains the dates for the 'combined' version (all centers)
  let objectAll = {};
  // loop through all centers
  for (let ct of Object.keys(tempObj)) {
    // loop through all dates
    for (let d of Object.keys(tempObj[ct])) {
      // if objectAll doesn't have the key 'd'
      if (!Object.keys(objectAll).includes(d)) {
        objectAll[d] = {};
        // loop through the 4 six-hour periods
        for (let p of Object.keys(tempObj[ct][d])) {
          if (tempObj[ct][d][p].available) {
            objectAll[d][p] = {};
            objectAll[d][p].available = true;
            objectAll[d][p].id = {};
            objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
          } else {
            objectAll[d][p] = {
              available: false,
              id: {}
            };
          }
        }
      } else {
        for (let p of Object.keys(tempObj[ct][d])) {
          if (tempObj[ct][d][p].available) {
            objectAll[d][p].available = true;
            objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
          }
        }
      }
    }
  }
  tempObj.all = objectAll;
  return tempObj;
}

// Set calendar periods for the six-hour periods
export function setCalendarPeriods(responseResults, dispatch, payload, allPeriods) {
  if (responseResults) {
    let tempObj = {};
    for (let p of responseResults) {
      if (!tempObj[p.center]) {
        tempObj[p.center] = {};
      }
      if (!tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")]) {
        tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")] = {
          "00": { available: false, id: null },
          "06": { available: false, id: null },
          "12": { available: false, id: null },
          "18": { available: false, id: null }
        };
      }
      tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
        moment.utc(p.date).format("HH")
      ].available = true;
      tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")][
        moment.utc(p.date).format("HH")
      ].id = p.id;
    }
    // The object that contains the dates for the 'combined' version (all centers)
    let objectAll = {};
    // loop through all centers
    for (let ct of Object.keys(tempObj)) {
      // loop through all dates
      for (let d of Object.keys(tempObj[ct])) {
        // if objectAll doesn't have the key 'd'
        if (!Object.keys(objectAll).includes(d)) {
          objectAll[d] = {};
          // loop through the 4 six-hour periods
          for (let p of Object.keys(tempObj[ct][d])) {
            if (tempObj[ct][d][p].available) {
              objectAll[d][p] = {};
              objectAll[d][p].available = true;
              objectAll[d][p].id = {};
              objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
            } else {
              objectAll[d][p] = {
                available: false,
                id: {}
              };
            }
          }
        } else {
          for (let p of Object.keys(tempObj[ct][d])) {
            if (tempObj[ct][d][p].available) {
              objectAll[d][p].available = true;
              objectAll[d][p].id[ct] = tempObj[ct][d][p].id;
            }
          }
        }
      }
    }
    tempObj.all = objectAll;

    dispatch(
      setPeriodDataKey({
        subObj: "periodData",
        type: payload.fileType,
        period: "six_hour",
        key: "dates",
        value: tempObj
      })
    );
    dispatch(
      setPeriodDataKey({
        subObj: "periodData",
        type: payload.fileType,
        period: "six_hour",
        key: "centers",
        // case insensitive sort so that "all" is first element
        value: Object.keys(tempObj).sort(function(a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        })
      })
    );
    if (!allPeriods) {
      if (isEmpty(payload.params)) {
        const firstCenter = Object.keys(tempObj).sort(function(a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        })[0];

        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedCenter",
            value: firstCenter
          })
        );

        const latestDate = Object.keys(tempObj[firstCenter]).sort()[
          Object.keys(tempObj[firstCenter]).length - 1
        ];

        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedDate",
            value: latestDate
          })
        );
      }
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "readyToFillMenu",
          value: true
        })
      );
    }
  }
}

// GCOS-specific helper functions (for monthly periods)
export function loadInitialPeriodsGCOS(limit, pageType, payload, baseline, dispatch) {
  let url = `${WDQMS_API}/gcos/periods/?network=${payload.fileType}&limit=${limit}${pageType}`;
  return fetchData(url)
    .then(response => {
      if (response.data.length === 0) {
        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "monthly",
            key: "noData",
            value: true
          })
        );
        return false;
      } else {
        if (isEmpty(payload.params)) {
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedPeriodType",
              value: "monthly"
            })
          );
        }

        dispatch(
          updatePeriodTypes({
            type: payload.fileType,
            value: "monthly"
          })
        );
        // For GCOS, API returns flat items with network, id, date (no center)
        let tempObj = {};
        let flatDates = {};
        for (let p of response.data) {
          const dateKey = moment.utc(p.date).format("YYYY-MM");
          if (!tempObj[p.network]) {
            tempObj[p.network] = {};
          }
          tempObj[p.network][dateKey] = { id: p.id };
          // Build flat date→id map for ftype.dates
          if (!flatDates[dateKey]) {
            flatDates[dateKey] = { id: p.id };
          }
        }
        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "monthly",
            key: "dates",
            value: tempObj
          })
        );
        dispatch(
          setPeriodDataKey({
            subObj: "periodData",
            type: payload.fileType,
            period: "monthly",
            key: "centers",
            value: Object.keys(tempObj).sort(function(a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            })
          })
        );
        if (
          !isEmpty(payload.params) &&
          payload.params.periodType === "monthly"
        ) {
          // GCOS doesn't use centers, only networks
          if (flatDates[payload.params.date]) {
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "selectedDate",
                value: payload.params.date
              })
            );
          } else {
            const latestDate = Object.keys(flatDates).sort()[
              Object.keys(flatDates).length - 1
            ];
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "selectedDate",
                value: latestDate
              })
            );
          }
        } else if (isEmpty(payload.params)) {
          const latestDate = Object.keys(flatDates).sort()[
            Object.keys(flatDates).length - 1
          ];
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "selectedDate",
              value: latestDate
            })
          );
        }
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "dates",
            value: flatDates
          })
        );
        if (
          isEmpty(payload.params) ||
          payload.params.periodType === "monthly"
        ) {
          dispatch(
            setProperty({
              type: payload.fileType,
              key: "readyToFillMenu",
              value: true
            })
          );
        }
        return true;
      }
    })
    .catch(error => {
      // If there are URL params requesting the monthly data
      // and an error while fetching the monthly data, trigger an error
      if (
        !isEmpty(payload.params) &&
        payload.params.periodType === "monthly"
      ) {
        dispatch(setError404());
      }
      console.log(error)
      notification.error({
        message: "Error fetching API",
        description: "There was an error while fetching the monthly data",
        top: 100,
        duration: 0
      });
      dispatch(
        setPeriodDataKey({
          subObj: "periodData",
          type: payload.fileType,
          period: "monthly",
          key: "errorFetchingApi",
          value: true
        })
      );
      return false;
    });
}

// GCOS-specific helper functions
export function loadAllPeriodsGCOS(payload, pageType) {
  let url = `${WDQMS_API}/gcos/periods/?network=${payload.fileType}${pageType}`;
  return fetchData(url).then(response => {
    // For GCOS, API returns flat items with network, id, date (no center)
    let tempObj = {};
    let flatDates = {};
    for (let p of response.data) {
      const dateKey = moment.utc(p.date).format("YYYY-MM");
      if (!tempObj[p.network]) {
        tempObj[p.network] = {};
      }
      tempObj[p.network][dateKey] = { id: p.id };
      // Build flat date→id map for ftype.dates
      if (!flatDates[dateKey]) {
        flatDates[dateKey] = { id: p.id };
      }
    }
    // Store flatDates in tempObj for setCalendarPeriodsGCOS to use
    tempObj.flatDates = flatDates;
    return tempObj;
  });
}

// GCOS-specific helper functions
export function setCalendarPeriodsGCOS(response, dispatch, payload, allDataFetched) {
  dispatch(
    setProperty({
      type: payload.fileType,
      key: "dates",
      value: response.flatDates
    })
  );
  dispatch(
    setPeriodDataKey({
      subObj: "periodData",
      type: payload.fileType,
      period: "monthly",
      key: "dates",
      value: response
    })
  );
  dispatch(
    setPeriodDataKey({
      subObj: "periodData",
      type: payload.fileType,
      period: "monthly",
      key: "centers",
      value: Object.keys(response).sort(function(a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      })
    })
  );
  if (!allDataFetched) {
    if (isEmpty(payload.params)) {
      const latestDate = Object.keys(response.flatDates).sort()[
        Object.keys(response.flatDates).length - 1
      ];
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: latestDate
        })
      );
    }
    dispatch(
      setProperty({
        type: payload.fileType,
        key: "readyToFillMenu",
        value: true
      })
    );
  }
}
